import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import '../../assets/js/scripts.js';

@Component({
  selector: 'app-main',
  templateUrl: './offer.component.html',
  //styleUrls: ['../../assets/sass/checkout/checkout.scss'],
})
export class OfferComponent implements OnInit {
  constructor(
    private breadcrumbsService: BreadcrumbsService,
  ) {}

  ngOnInit() {
    this.breadcrumbsService.translateBreadcrumb(
      '/service',
      'Usługi'
    );
    this.breadcrumbsService.translateBreadcrumbWithRegex(
      '/service/select',
      'Lista usług'
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/service/offer.component.ts